export default __webpack_public_path__ + "static/media/Prison-3D-Model-01.e5da42e4.jpg";